import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjouteCarte = async (data) => {
  return await axios.post(`${BASE_URL}/api/restaurant/ajouteCarte`, data, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}
const AfficheCarte = async (idRestaurant) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheCarte/${idRestaurant}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}

const AfficheCarteRestaurant = async (idRestaurant) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheCarteRestaurant/${idRestaurant}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}


const AfficheBoisson = async () => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheBoisson`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}


export { AjouteCarte, AfficheCarte , AfficheCarteRestaurant, AfficheBoisson }